<template>
    <div class="main">

      <ProgressBar/>

      <section class="section">

        <h2>Gebruik een AED-toestel</h2>

        <p class="text-blue">Op veel plaatsen is er een AED. Dat is een draagbare defibrillator, een toestel waarmee je het hartritme weer kunt herstellen. Het gebruik is veel eenvoudiger dan mensen denken. Bekijk hier hoe het toestel werkt.</p>

        <iframe width="90%" height="215" src="https://www.youtube.com/embed/n-iwKRKi3cQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

      </section>
     
      <section class="click-section">
        <Clickheart class="click-heart" @click="nextScene('/rea')"/>
  

    </section>

    </div>
</template>
<script>

import ProgressBar from "./progress-bar.vue";
import Clickheart from "./click-heart.vue"; 
  
  export default {
    name: 'Scene2-yellow',
    components: {
        ProgressBar,
        Clickheart
    },
    mounted(){
      this.$gtm.trackView('gebruik een aed-toestel', '/aed');  
    },
    unmounted(){
  
    },
    methods:{

    nextScene(path){
        this.$router.push({ path: path });
    }

    }

    }
</script>
<style scoped>

iframe{
  position: relative;
  z-index: 10;
  opacity: 0;
  animation: appear 1s ease-in-out 0.4s forwards;
}
.main{
    background-color: var(--color-yellow);
}
header{
    display: grid;
    columns: 4;
    animation: appear 1s ease-in-out forwards;
}
h2{
    color: var(--color-red);
    margin-top: 10px;
    margin-bottom: 10px;
    opacity: 0;

    animation: appear 1s ease-in-out 0.1s forwards;
}
.text-blue{
    margin-top: 0;
    color: var(--color-dark-blue);
    font-weight: 500;
    font-size: 15px;
    animation: appear 1s ease-in-out 0.3s forwards;
}

/* .click-section{
    opacity: 0;
    animation: appear 1s ease-in-out 0.5s forwards;
} */
@media (min-width: 900px){
h2{
  font-size: 3.125rem;
  
}
.section{
    align-items: stretch;
    margin-left: 5%;
    margin-top: 10%;
    max-width: 50%
  }
.text-blue{
    max-width: 670px;
    font-size: 1.875rem;
    /* color: var(--color-purple); */
  }
iframe{
position: absolute;
right: 3%;
top: 30%;

max-width: 800px;
width: 40%;
max-height: 450px;
height: 40%;
}
  }
</style>